import React from 'react'
import styled from 'styled-components'

// Design System imports
import { colors, spacing, heading, typographyMixin, mediaQuery } from 'src/constants/marketing-ds'
import { SectionContainer, SectionHeader } from 'src/components/common/SharedComponents'

const DealSection = ({ market = 'us', lang = 'en', title, savingsText, noContracts, cloudDvr }) => {
  const dealsText = {
    en: {
      headline: (
        <>
          How is Fubo <span className="mobile-line-break"> better than cable TV?</span>
        </>
      ),
      savingsText: 'More savings.',
      noContracts: (
        <>
          No contracts, <span className="no-wrap mobile-line-break">cancel anytime.</span>
        </>
      ),
      cloudDvr: 'Cloud DVR included.',
      noContractsMobile: 'No contracts',
    },
    es: {
      headline: <>¿Por qué Fubo es mejor que la TV por cable?</>,
      savingsText: 'Ahorras más.',
      noContracts: 'Cancelas cuando quieras.',
      cloudDvr: 'Grabas sin límite.',
    },
  }

  return (
    <SectionContainer backgroundColor={colors.slate[30]}>
      <StyledDealSection>
        <SectionHeader title={title || dealsText[lang].headline} variant="light" />
        <div className="deal-content">
          <div className="deal-item">{savingsText || dealsText[lang].savingsText}</div>
          <div className="deal-item">{noContracts || dealsText[lang].noContracts}</div>
          <div className="deal-item">{cloudDvr || dealsText[lang].cloudDvr}</div>
        </div>
      </StyledDealSection>
    </SectionContainer>
  )
}

export default DealSection

const StyledDealSection = styled.section`
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${spacing.xl} 0;
  gap: ${spacing.md};

  ${mediaQuery.tablet} {
    padding: ${spacing.xxl} 0;
  }

  ${mediaQuery.desktop} {
    gap: ${spacing.lg};
  }


  .deal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    width: 100%;
   gap: ${spacing.md};

    ${mediaQuery.tablet} {
      gap ${spacing.lg};
    }

    ${mediaQuery.desktop} {
      gap: ${spacing.sm};
    }
    
  }

  .deal-item {
    ${typographyMixin(heading.lg)}
    text-align: center;
    background: ${colors.gradients.orange.light};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0;
    line-height: 1.25;
    width: auto;

    ${mediaQuery.tablet} {
      ${typographyMixin(heading.xxl)}
    }

  }
`
